import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import { string } from 'yup';
class PasswordRequirements extends Component {
    patterns = {
        length: (v, min) => string().min(min).isValid(v),
        special: (v, min) => string().matches(new RegExp(`(?:.*[^A-Za-z0-9]){${min}}`)).isValid(v),
        caps: (v, min) => string().matches(new RegExp(`(?:.*[A-Z]){${min}}`)).isValid(v),
        number: (v, min) => string().matches(new RegExp(`(?:.*[0-9]){${min}}`)).isValid(v)
    };
    rules = [];
    finalRule;
    field;
    initialized() {
        super.initialized();
        this.parseRules();
        this.findPasswordField();
        this.refresh();
    }
    findPasswordField() {
        const inputs = Array.from(this.el.parentNode?.querySelectorAll('input[type="password"]'));
        this.field = inputs?.[0];
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.field?.[method]('input', this.onPasswordChange.bind(this));
        this.field?.[method]('blur', this.onPasswordBlur.bind(this));
    }
    parseRules() {
        this.rules = this.refs.rules?.map((rule) => {
            return {
                type: rule.dataset.ruleType,
                min: Number.parseInt(rule.dataset.ruleMin),
                el: rule
            };
        });
    }
    async onPasswordBlur() {
        this.el.classList.toggle('blurred', true);
    }
    async onPasswordChange(e) {
        this.el.classList.toggle('blurred', false);
        const value = e.target.value;
        for (let i = 0; i < this.rules?.length; i++) {
            const { type, min, el } = this.rules[i];
            this.rules[i].valid = await this.patterns?.[type]?.(value, min);
            el.classList.toggle('password-requirements__item--valid', this.rules[i].valid);
        }
    }
}
export default PasswordRequirements;
